import { render } from "./HomeGalleryButtonMenu.vue?vue&type=template&id=d86c0324&scoped=true"
import script from "./HomeGalleryButtonMenu.vue?vue&type=script&lang=js"
export * from "./HomeGalleryButtonMenu.vue?vue&type=script&lang=js"

import "./HomeGalleryButtonMenu.vue?vue&type=style&index=0&id=d86c0324&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d86c0324"

export default script